import { useState } from 'react';

const initAppleSdk = () => {
  // add apple sdk script
  if (window.AppleID || document.getElementById('apple-sdk')) {
    return;
  }

  const script = document.createElement('script');
  script.id = 'apple-sdk';
  script.src =
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

  script.onload = function () {
    window.AppleID.auth.init({
      clientId: import.meta.env.VITE_APPLE_CLIENT_ID,
      redirectURI: import.meta.env.VITE_APPLE_REDIRECT_URI,
      scope: 'name email',
      usePopup: true,
    });
  };
  document.body.appendChild(script);
};

const useAppleLogin = () => {
  initAppleSdk();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const Login = async () => {
    setLoading(true);
    try {
      const data = await window.AppleID.auth.signIn();
      /* response = {
           "authorization": {
             "code": "[CODE]",
             "id_token": "[ID_TOKEN]",
             "state": "[STATE]"
           },
           "user": {
             "email": "[EMAIL]",
             "name": {
               "firstName": "[FIRST_NAME]",
               "lastName": "[LAST_NAME]"
             }
           }
      }*/
      setData(data.authorization);
      setLoading(false);
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  return [Login, data, loading, error];
};

export default useAppleLogin;
